import React from "react";
import imgName from "./Img/dtp.jpg";
import photoshopLogo from "./Img/graph4.jpg";
import AdobePic from "./Img/dtp2.png";

import { Link } from "react-router-dom";
import {
  FaLayerGroup,
  FaMagic,
  FaFont,
  FaPaintBrush,
  FaRunning,
  FaFileExport,
  FaFileImage,
} from "react-icons/fa";

// topics
const topics = [
  {
    icon: <FaPaintBrush />,
    title: "Introduction to DTP",
    description:
      "Understand the basics of desktop publishing and its applications.",
  },
  {
    icon: <FaFont />,
    title: "Typography & Layout",
    description:
      "Learn to design effective text layouts and font usage for print media.",
  },
  {
    icon: <FaLayerGroup />,
    title: "Page Design & Composition",
    description:
      "Arrange text, images, and graphics to create balanced page layouts.",
  },
  {
    icon: <FaFileExport />,
    title: "Graphic Integration",
    description:
      "Incorporate vector and raster graphics seamlessly into your designs.",
  },
  {
    icon: <FaMagic />,
    title: "Color Management",
    description: "Manage color profiles for accurate printing results.",
  },
  {
    icon: <FaFileImage />,
    title: "Printing & Exporting",
    description:
      "Prepare files correctly for professional printing and digital distribution.",
  },
];

// usage areas
const usageAreas = [
  {
    icon: <FaPaintBrush />,
    title: "DTP Fundamentals",
    description:
      "Learn the essentials of desktop publishing and print media workflows.",
  },
  {
    icon: <FaFont />,
    title: "Typography & Fonts",
    description:
      "Explore typefaces, font pairing, and text formatting for effective communication.",
  },
  {
    icon: <FaFileExport />,
    title: "Layout & Page Design",
    description:
      "Create professional multi-page documents with balanced text and visuals.",
  },
  {
    icon: <FaMagic />,
    title: "Graphic Integration",
    description:
      "Combine images, graphics, and text for eye-catching publications.",
  },
  {
    icon: <FaFileImage />,
    title: "Prepress & Color Management",
    description:
      "Prepare files for printing with color accuracy and bleed settings.",
  },
  {
    icon: <FaRunning />,
    title: "Publishing & Distribution",
    description:
      "Understand digital and print publishing processes and file export formats.",
  },
];

// future scope
const futureScope = [
  {
    icon: "🎬",
    title: "Pixar",
    text: "Uses Adobe for animation and post-production.",
  },
  {
    icon: "🎥",
    title: "DreamWorks",
    text: "Integrates Adobe tools in movie workflows.",
  },
  {
    icon: "🌌",
    title: "Industrial Light & Magic (ILM)",
    text: "Relies on Adobe for VFX editing.",
  },
  {
    icon: "🎮",
    title: "Blizzard Entertainment",
    text: "Uses Adobe in game cinematic production.",
  },
  {
    icon: "🕹️",
    title: "Ubisoft",
    text: "Employs Adobe for 3D art and game assets.",
  },
  {
    icon: "⚽",
    title: "Electronic Arts (EA)",
    text: "Leverages Adobe for sports game visuals.",
  },
  {
    icon: "🎭",
    title: "Sony Pictures Animation",
    text: "Uses Adobe in animated film production.",
  },
  {
    icon: "🖥️",
    title: "Weta Digital",
    text: "Incorporates Adobe for post-production work.",
  },
  {
    icon: "💻",
    title: "Autodesk",
    text: "Partners with Adobe for design workflows.",
  },
  {
    icon: "👟",
    title: "Nike",
    text: "Uses Adobe for marketing and branding visuals.",
  },
  {
    icon: "🚗",
    title: "Mercedes-Benz",
    text: "Creates campaigns with Adobe Creative Suite.",
  },
  {
    icon: "🥤",
    title: "Coca-Cola",
    text: "Designs ads and packaging using Adobe.",
  },
  {
    icon: "🔍",
    title: "Google",
    text: "Uses Adobe for creative design and branding.",
  },
  {
    icon: "🍏",
    title: "Apple",
    text: "Employs Adobe tools for promotional visuals.",
  },
  {
    icon: "🏰",
    title: "Disney",
    text: "Creates digital media with Adobe software.",
  },
];

// reusable section title style
const sectionTitleStyle = {
  textAlign: "center",
  marginBottom: "40px",
  fontSize: "2.5rem",
  fontWeight: "bold",
  color: "#000", // black heading
};

const DTP = () => {
  return (
    <div className="overflow-hidden">
      {/* HERO SECTION */}
      <section
        style={{
          backgroundImage: `url(${imgName})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "500px", // reduced height
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Dark overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
          }}
        />

        {/* Hero Text */}
        <div
          style={{
            position: "relative",
            zIndex: 1,
            padding: "0 20px",
            color: "white",
          }}
        >
          <h1
            style={{
              fontSize: "42px",
              fontWeight: "bold",
              marginBottom: "15px",
              color: "#fff",
            }}
            data-aos="fade-down"
          >
            Desktop Publishing (DTP)
          </h1>

          <p
            style={{
              fontSize: "18px",
              maxWidth: "800px",
              margin: "0 auto 20px",
            }}
            data-aos="fade-up"
          >
            Learn to design and produce professional-quality printed and digital
            materials, combining text and graphics seamlessly with powerful
            desktop publishing tools.
          </p>

          {/* Enroll Button in Hero */}

          <Link
            to="/contact"
            style={{
              backgroundColor: "#ff5722",
              color: "white",
              border: "none",
              padding: "12px 28px",
              borderRadius: "8px",
              fontSize: "16px",
              cursor: "pointer",
              transition: "0.3s",
              textDecoration: "none", // removes underline
              display: "inline-block",
            }}
            className="animate-bounce"
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#e64a19")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#ff5722")
            }
          >
            Enroll Now
          </Link>
        </div>
      </section>

      {/* TOPICS SECTION */}
      <section
        style={{ padding: "60px 20px", maxWidth: "1200px", margin: "0 auto" }}
      >
        <h2
          style={{
            textAlign: "center",
            marginBottom: "40px",
            fontSize: "2.5rem",
            fontWeight: "bold",
            color: "#000",
          }}
          data-aos="fade-up"
        >
          Topics You Will Learn
        </h2>

        <div
          style={{
            display: "flex",
            gap: "40px",
            alignItems: "stretch",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {/* Left: Topics */}
          <div style={{ flex: "1", minWidth: "300px", maxWidth: "600px" }}>
            {topics.map((topic, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  gap: "15px",
                  alignItems: "flex-start",
                  padding: "15px",
                  marginBottom: "15px",
                  background: "#f8f8f8",
                  borderRadius: "10px",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  cursor: "pointer",
                }}
                data-aos="fade-up"
                data-aos-delay={i * 100}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 20px rgba(89, 141, 201, 0.89)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  style={{ fontSize: "28px", color: "#279dd0ff" }}
                  className="animate-wiggle"
                >
                  {topic.icon}
                </div>
                <div>
                  <h3
                    style={{
                      margin: "0 0 5px",
                      fontWeight: "bold",
                      color: "#000",
                    }}
                  >
                    {topic.title}
                  </h3>
                  <p style={{ margin: 0, fontSize: "14px", color: "#555" }}>
                    {topic.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Right: Image */}
          <div
            style={{
              flex: "1",
              minWidth: "300px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            data-aos="fade-left"
          >
            <img
              src="/assets/676ef3bf2caa0f207530c87fbff3c24d.jpg"
              alt="Adobe Photoshop"
              style={{
                width: "100%",
                maxWidth: "450px",
                maxHeight: "350px",
                objectFit: "cover",
                borderRadius: "15px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              }}
            />
          </div>
        </div>
      </section>

      {/* WHERE IT CAN BE USED */}
      <section className="py-5 bg-light">
        <h1 style={sectionTitleStyle} data-aos="fade-up">
          Where It Can Be Used
        </h1>
        <div className="container">
          <div className="row g-4">
            {usageAreas.map((area, i) => {
              const colors = [
                "#ff9800",
                "#4caf50",
                "#2196f3",
                "#e91e63",
                "#9c27b0",
                "#00bcd4",
              ];
              return (
                <div
                  key={i}
                  className="col-sm-6 col-lg-4"
                  data-aos="zoom-in-up"
                  data-aos-delay={i * 100}
                >
                  <div
                    className="p-4 text-center rounded position-relative h-100"
                    style={{
                      background: "#fff",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
                      animation: "shake 3s infinite ease-in-out",
                    }}
                  >
                    {/* colorful corner */}
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        width: "45px",
                        height: "45px",
                        background: `linear-gradient(135deg, ${
                          colors[i % colors.length]
                        }, transparent)`,
                        borderTopRightRadius: "15px",
                        boxShadow: `0 0 10px ${colors[i % colors.length]}`,
                      }}
                    ></div>
                    <div
                      style={{
                        fontSize: "2rem",
                        color: colors[i % colors.length],
                      }}
                      className="animate-bounce"
                    >
                      {area.icon}
                    </div>
                    <h5 className="fw-bold" style={{ color: "#000" }}>
                      {area.title}
                    </h5>
                    <p className="text-muted small">{area.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* COMPANIES Img */}
      <section style={{ padding: 0, margin: 0, textAlign: "center" }}>
        <h1 style={sectionTitleStyle}>We Are Going To Work In</h1>

        <img
          src={AdobePic}
          alt="Adobe Photoshop Everywhere"
          data-aos="zoom-in"
          style={{
            width: "100%",
            height: "auto",
            maxHeight: "80vh",
            objectFit: "cover",
            borderRadius: "10px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
          }}
        />

        <p
          style={{
            maxWidth: "900px",
            margin: "30px auto 0",
            fontSize: "1.2rem",
            lineHeight: "1.6",
            color: "#444",
            padding: "0 20px",
          }}
        >
          Desktop Publishing (DTP) enables the creation and arrangement of text
          and graphics using specialized software to design professional
          documents like brochures, magazines, and flyers. In real time, it
          allows designers to visually compose layouts, apply styles, and
          instantly preview print-ready outputs before final production.
        </p>
      </section>

      {/* Future Scope */}
      <section
        style={{
          padding: "60px 20px",
          background: "#fff",
          color: "#333",
          textAlign: "center",
        }}
      >
        <h2 style={sectionTitleStyle} data-aos="fade-up">
          Future Scope
        </h2>

        <div
          id="my-sc"
          style={{ display: "flex", width: "100%", overflow: "hidden" }}
        >
          {[0, 1].map((groupIndex) => (
            <div
              key={groupIndex}
              className="scroll-group"
              style={{ display: "flex", gap: "20px", flexShrink: 0 }}
            >
              {futureScope.map((item, i) => {
                const colors = ["#ff5722", "#673ab7", "#3f51b5", "#009688"];
                return (
                  <div
                    key={i}
                    style={{
                      position: "relative",
                      background: "linear-gradient(145deg, #fdfdfd, #f3f3f3)",
                      borderRadius: "20px",
                      padding: "25px",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                      border: "1px solid #eee",
                      transition: "transform 0.3s ease",
                      minWidth: "250px",
                      flexShrink: 0,
                      animation: "shake 3s infinite ease-in-out",
                      animationDelay: `${i * 500}ms`,
                      color: "#333",
                    }}
                    data-aos="fade-up"
                    data-aos-delay={i * 150}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        width: "35px",
                        height: "35px",
                        background: `linear-gradient(135deg, ${
                          colors[i % colors.length]
                        }, transparent)`,
                        borderTopRightRadius: "20px",
                        boxShadow: `0 0 10px ${colors[i % colors.length]}`,
                      }}
                    ></div>

                    <div
                      style={{ fontSize: "2rem", marginBottom: "10px" }}
                      className="animate-float"
                    >
                      {item.icon}
                    </div>
                    <h3
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: "bold",
                        marginBottom: "10px",
                        color: "#000",
                      }}
                    >
                      {item.title}
                    </h3>
                    <p style={{ fontSize: "0.95rem", color: "#555" }}>
                      {item.text}
                    </p>
                  </div>
                );
              })}
            </div>
          ))}
        </div>

        <style jsx>{`
          #my-sc {
            overflow: hidden;
            white-space: nowrap;
          }

          .scroll-group {
            animation: marquee 20s linear infinite;
          }

          @keyframes marquee {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }

          @keyframes shake {
            0%,
            100% {
              transform: translate(0, 0) rotate(0);
            }
            20% {
              transform: translate(-1px, 1px) rotate(-0.5deg);
            }
            40% {
              transform: translate(1px, -1px) rotate(0.5deg);
            }
            60% {
              transform: translate(-1px, 1px) rotate(-0.5deg);
            }
            80% {
              transform: translate(1px, -1px) rotate(0.5deg);
            }
          }
        `}</style>
      </section>

      {/* FINAL ENROLL SECTION */}
      <section
        style={{
          background: "#f8f9fa",
          padding: "60px 20px",
          textAlign: "center",
        }}
      >
        <h2 style={sectionTitleStyle}>Ready to Start Your Journey?</h2>
        <p
          style={{
            fontSize: "18px",
            color: "#555",
            maxWidth: "700px",
            margin: "0 auto 20px",
          }}
        >
          Enroll today and gain hands-on skills in desktop publishing that will
          help you create professional documents, designs, and publications for
          both print and digital platforms.
        </p>
        <Link
          to="/contact"
          style={{
            display: "inline-block",
            textDecoration: "none",
            backgroundColor: "#2196f3",
            color: "white",
            border: "none",
            padding: "14px 32px",
            borderRadius: "10px",
            fontSize: "18px",
            cursor: "pointer",
            transition: "0.3s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#1976d2")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "#2196f3")
          }
          className="animate-float"
        >
          Enroll Now
        </Link>
      </section>
    </div>
  );
};

export default DTP;
